import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Input, InputPassword } from 'components/fields'

export default class Account extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    prefix: PropTypes.string
  }

  static defaultProps = {
    disabled: false,
    prefix: null
  }

  render() {
    const { disabled } = this.props
    const prefix = this.props.prefix && this.props.prefix.length > 0
      ? `${this.props.prefix}.`
      : ''

    return (
      <div>
        <div className="row">
          <div className="col-xs-6">
            <Input
              name={`${prefix}email`}
              label="Email"
              intlKey="label.email"
              disabled
              dataTestId="accountEmailInput"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <InputPassword
              name={`${prefix}password`}
              label="Password"
              intlKey="label.password"
              type="password"
              disabled={disabled}
              dataTestId="accountPasswordInput"
            />
          </div>
          <div className="col-xs-12 col-sm-6">
            <Input
              name={`${prefix}passwordAgain`}
              label="Password again"
              intlKey="label.password_again"
              type="password"
              disabled={disabled}
              dataTestId="accountPasswordInputAgain"
            />
          </div>
        </div>
      </div>
    )
  }
}
